















































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Navigation extends Vue {
  showNav = false;

  goToRoute(route: string) {
    console.log("goToRoute", route);
    this.showNav = false;
    this.$router.push(route);
  }

}
